import React from 'react';
import {
	List,
	Filter,
	TextInput,
	SelectInput,
	DateInput,
	Datagrid,
	TextField,
	FunctionField,
} from 'react-admin';
import { SubscriptionStatus, StripeLink } from './subscriptionShared';

const STATUS_CHOICES = [
	{ id: 'active', name: 'Active' },
	{ id: 'trialing', name: 'Trialing' },
	{ id: 'past_due', name: 'Past due' },
	{ id: 'canceled', name: 'Canceled' },
	{ id: 'incomplete', name: 'Incomplete' },
	{ id: 'unpaid', name: 'Unpaid' },
];

const SubscriptionFilter = (props: any) => (
	<Filter {...props}>
		<TextInput label="Search BA / sub id" source="q" alwaysOn resettable />
		<SelectInput
			label="Status"
			source="status"
			choices={STATUS_CHOICES}
			alwaysOn
			emptyText="All"
			resettable
		/>
		<DateInput label="Renew after" source="current_period_end_after" />
		<DateInput label="Renew before" source="current_period_end_before" />
		<DateInput label="Started after" source="current_period_start_after" />
		<DateInput label="Started before" source="current_period_start_before" />
	</Filter>
);

const formatDate = (dateString: string) => {
	if (!dateString) return '-';
	return new Date(dateString).toLocaleDateString('fr-FR');
};

export const SubscriptionList = (props: any) => (
	<List
		{...props}
		filters={<SubscriptionFilter />}
		exporter={false}
		sort={{ field: 'current_period_end', order: 'ASC' }}
	>
		<Datagrid rowClick={(id) => `${id}`}>
			<TextField source="id" />
			<FunctionField
				label="Billing Account"
				render={(record: any) => record.billingAccount?.name || record.billingAccountId}
			/>
			<FunctionField
				label="Plan"
				render={(record: any) => record.plan?.name || record.planId}
			/>
			<FunctionField
				label="Status"
				render={(record: any) => <SubscriptionStatus status={record.status} />}
			/>
			<TextField source="stripeSubscriptionId" label="Stripe Sub ID" />
			<FunctionField
				label="Period Start"
				render={(record: any) => formatDate(record.currentPeriodStart)}
			/>
			<FunctionField
				label="Period End"
				render={(record: any) => formatDate(record.currentPeriodEnd)}
			/>
			<FunctionField
				label="Stripe"
				render={(record: any) => <StripeLink subId={record.stripeSubscriptionId} />}
			/>
		</Datagrid>
	</List>
);
